import React from "react";
import SectionTitle from "../common/SectionTitle";
import { useFormSection, FormSectionProps } from "../../hooks/useFormSection";

const yesNoOptions = [
  { label: "Yes", value: "yes" },
  { label: "No", value: "no" }
];

const HealthConcernsSectionV2: React.FC<FormSectionProps> = (props) => {
  const { Field } = useFormSection(props);

  return (
    <section>
      <SectionTitle>Health Concerns</SectionTitle>
      
      <Field
        path="healthConcerns.mainConcern"
        label="What is Your Main Health Concern?"
        subLabel="(describe with symptoms & duration)"
        type="textarea"
        rows={4}
      />
      
      <Field
        path="healthConcerns.problemFirstBegin"
        label="When did your health problem first begin?"
        type="textarea"
        rows={4}
      />
      
      <Field
        path="healthConcerns.lifeAtTheTime"
        label="What else was going on in your life at that time?"
        subLabel="(change in diet, physical activity, job, relationships, and any additional details you remember.)"
        type="textarea"
        rows={4}
      />
      
      <Field
        path="healthConcerns.worseBetter"
        label="What makes you feel worse or better?"
        type="textarea"
        rows={4}
      />
      
      <Field
        path="healthConcerns.healthGoals"
        label="What is your health goal(s)?"
        type="textarea"
        rows={4}
      />
      
      <Field
        path="healthConcerns.biggestObstacle"
        label="What is your biggest obstacle(s)?"
        type="textarea"
        rows={4}
      />
      
      <Field
        path="healthConcerns.commitmentScale"
        label="On a scale of 1-10 how ready are you to commit to this goal?"
        type="slider"
        min={1}
        max={10}
      />
      
      <Field
        path="healthConcerns.takesMedsForConcern"
        label="Do you currently take medications / supplements for your current health concern?"
        type="radio"
        options={yesNoOptions}
      />
    </section>
  );
};

export default HealthConcernsSectionV2;